export const LOCATION_TYPE = {
	ENGINEER: 'employee',
	LOCATION: 'storage',
	VENDOR: 'vendor',
}
